module.exports = "https://cdn.prod.zoopla.co.uk/_next/static/images/portability-aadc8c7d5d554b2b4730aaf9d862005f.svg";